import React from "react"
import { Container, Row, Col } from "reactstrap"
import { version } from "../../../package.json"

const Footer = props => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Reval Soft.</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Versión {version}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
